function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { identifyPlaybackTypeKey } from '../../../utils/playback-vendor-relation';
var AUDIO_TRACK_CHANGE_DEFAULT_SAFE_MARGIN_SECONDS = 0;
export function getTracksConfig(playoutData) {
    var _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_Shaka, _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig, _CoreVideoInternal_getPropositionExtensions, _propositionConfigTracks_default, _propositionConfigTracks_deviceType;
    var propositionConfigTracks = (_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig = _CoreVideoInternal_getPropositionExtensions.propositionPlayerConfig) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_Shaka = _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig.Shaka) === null || _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_Shaka === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_propositionPlayerConfig_Shaka.tracks;
    var deviceType = CoreVideoInternal.deviceType;
    var playbackTypeKey = identifyPlaybackTypeKey(playoutData.type);
    var _propositionConfigTracks_default_playbackTypeKey;
    var defaultTracksConfig = (_propositionConfigTracks_default_playbackTypeKey = propositionConfigTracks === null || propositionConfigTracks === void 0 ? void 0 : (_propositionConfigTracks_default = propositionConfigTracks.default) === null || _propositionConfigTracks_default === void 0 ? void 0 : _propositionConfigTracks_default[playbackTypeKey]) !== null && _propositionConfigTracks_default_playbackTypeKey !== void 0 ? _propositionConfigTracks_default_playbackTypeKey : {};
    var _propositionConfigTracks_deviceType_playbackTypeKey;
    var tracksConfig = _object_spread({}, defaultTracksConfig, (_propositionConfigTracks_deviceType_playbackTypeKey = propositionConfigTracks === null || propositionConfigTracks === void 0 ? void 0 : (_propositionConfigTracks_deviceType = propositionConfigTracks[deviceType]) === null || _propositionConfigTracks_deviceType === void 0 ? void 0 : _propositionConfigTracks_deviceType[playbackTypeKey]) !== null && _propositionConfigTracks_deviceType_playbackTypeKey !== void 0 ? _propositionConfigTracks_deviceType_playbackTypeKey : {});
    if (tracksConfig.audioTracksSwitchSafeMarginSeconds === undefined) {
        tracksConfig.audioTracksSwitchSafeMarginSeconds = AUDIO_TRACK_CHANGE_DEFAULT_SAFE_MARGIN_SECONDS;
    }
    return tracksConfig;
}

//# sourceMappingURL=tracks-config.js.map